import { gql } from '@apollo/client';

export const GENERIC_FILTER_PARAM_QUERY = gql`
  query genericFilterParam($paramId: Int!) {
    genericFilterParam(paramId: $paramId) {
      paramId
      paramName
      paramCode
      paramTypeId
      inactive
      genericFilterParamXContexts {
        id
        paramId
        contextId
        contextName
      }
    }
  }
`;

export const GENERIC_FILTER_PARAM_CONTEXTS_QUERY = gql`
  query genericFilterParamContexts {
    genericFilterParamContexts {
      id
      name
    }
  }
`;

export const GENERIC_FILTER_PARAM_TYPES_QUERY = gql`
  query genericFilterParamTypes {
    genericFilterParamTypes {
      id
      name
    }
  }
`;
